(function(){
  'use strict';

  function debounce(fn, ms) {
    var t;
    return function(arg) { clearTimeout(t); t = setTimeout(function(){ fn(arg); }, ms); };
  }

  function updateCart(key, qty, wrapper) {
    if (wrapper) wrapper.classList.add('is-loading');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r){ return r.json(); })
    .then(function(cart){
      document.querySelectorAll('[data-cart-count], .cart-count').forEach(function(el){
        el.textContent = cart.item_count;
        if (cart.item_count === 0) el.setAttribute('hidden','');
        else el.removeAttribute('hidden');
      });
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
      var cartItems = document.querySelector('[data-cart-items]');
      if (cartItems) {
        fetch('/?section_id=main-cart')
          .then(function(r){ return r.text(); })
          .then(function(html){
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var sel = ['[data-cart-items]','[data-cart-prices]','[data-cart-discounts]'];
            sel.forEach(function(s){
              var n = doc.querySelector(s), c = document.querySelector(s);
              if (n && c) c.innerHTML = n.innerHTML;
            });
            bindQtyButtons();
          })
          .catch(function(){ if(wrapper) wrapper.classList.remove('is-loading'); });
      } else {
        window.location.reload();
      }
    })
    .catch(function(){ if (wrapper) wrapper.classList.remove('is-loading'); });
  }

  var doUpdate = debounce(function(p){ updateCart(p.key, p.qty, p.wrapper); }, 300);

  function bindQtyButtons() {
    document.querySelectorAll('[data-increase-qty]').forEach(function(btn){
      if (btn._qf) return; btn._qf = true;
      btn.addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation();
        var w = btn.closest('[data-quantity-wrapper]');
        var inp = w && w.querySelector('[data-quantity-value]');
        if (!inp) return;
        var max = parseInt(inp.getAttribute('max')||'9999',10);
        var step = parseInt(inp.getAttribute('step')||'1',10);
        var cur = parseInt(inp.value||'1',10);
        var next = Math.min(cur+step, max);
        if (next===cur) return;
        inp.value = next;
        doUpdate({ key: inp.dataset.id, qty: next, wrapper: w });
      });
    });

    document.querySelectorAll('[data-decrease-qty]').forEach(function(btn){
      if (btn._qf) return; btn._qf = true;
      btn.addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation();
        var w = btn.closest('[data-quantity-wrapper]');
        var inp = w && w.querySelector('[data-quantity-value]');
        if (!inp) return;
        var step = parseInt(inp.getAttribute('step')||'1',10);
        var cur = parseInt(inp.value||'1',10);
        var next = Math.max(cur-step, 0);
        inp.value = next;
        doUpdate({ key: inp.dataset.id, qty: next, wrapper: w });
      });
    });

    document.querySelectorAll('[data-quantity-value]').forEach(function(inp){
      if (inp._qf) return; inp._qf = true;
      inp.addEventListener('change', function(){
        var w = inp.closest('[data-quantity-wrapper]');
        var qty = parseInt(inp.value,10);
        if (isNaN(qty)||qty<0) qty=0;
        doUpdate({ key: inp.dataset.id, qty: qty, wrapper: w });
      });
    });
  }

  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded', bindQtyButtons);
  else bindQtyButtons();

  document.addEventListener('cart:refresh', function(){ setTimeout(bindQtyButtons, 150); });

})();
